var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "menu-item",
      attrs: { to: _vm.url },
      nativeOn: {
        click: function($event) {
          _vm.$store.commit("setPrevFormsTab", null)
        }
      }
    },
    [
      _c("div", {
        staticClass: "header-svg",
        domProps: { innerHTML: _vm._s(_vm.svg[_vm.svgIcon]) }
      }),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.$t("HEADER." + _vm.name)))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12620538", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12620538","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/NavItem.vue
// module id = 949
// module chunks = 2